var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 123,
    viewBox: "0 0 166 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2557 76.2578V89.0837C20.2557 95.713 16.1726 99.1119 10.5029 99.1119C5.09904 99.1119 0.500488 95.8413 0.500488 89.0837V76.2578H4.71247V89.0837C4.71247 93.0918 7.03189 95.2722 10.5352 95.2722C14.0384 95.2722 16.0357 92.9314 16.0357 89.0837V76.2578H20.2557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4192 76.1937H46.6633V98.6389H44.0299L32.1912 83.4884V98.6069H27.939V76.1616H31.3859L42.4192 90.0616V76.1937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8066 98.6469V76.2017H58.0186V98.6469H53.8066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2266 98.647V76.2578H81.406V80.33H69.4707V86.4464H80.7456V90.3502H69.4707V98.647H65.2266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.358 87.5686C110.294 93.3643 106.726 99.16 98.8095 99.16C90.8929 99.16 87.2607 93.4926 87.2607 87.6007C87.2607 81.7088 91.0539 75.7769 98.8417 75.7769C106.629 75.7769 110.423 81.7088 110.358 87.5686ZM91.4083 87.6648C91.5049 91.3442 93.5022 95.2882 98.8095 95.2882C104.117 95.2882 106.114 91.2801 106.178 87.6328C106.243 83.9854 104.117 79.6166 98.8095 79.6166C93.5022 79.6166 91.2875 83.8812 91.4083 87.6648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.677 98.6469H131.627L125.064 91.1518H120.973V98.6469H116.729V76.2017C120.296 76.2017 123.872 76.2017 127.44 76.2017C132.747 76.2017 135.55 79.7608 135.55 83.6326C135.55 86.7109 134.132 89.8131 129.856 90.6788L136.677 98.3343V98.6469ZM120.973 80.1697V87.3842H127.415C130.121 87.3842 131.281 85.5886 131.281 83.793C131.281 81.9973 130.089 80.2097 127.415 80.2097L120.973 80.1697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.256 82.4383L153.92 92.1779H153.114L145.939 82.4063V98.7111H141.694V76.2659H146.583L153.63 85.8853L160.676 76.2659H165.509V98.7111H161.264L161.256 82.4383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9219 120.114H43.8684L42.5476 123.008H39.4067L46.3086 107.681H49.4736L56.3835 123.008H53.2185L51.9219 120.114ZM47.8951 110.896L45.0361 117.429H50.7541L47.8951 110.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5698 122.976H70.1149L65.6211 117.854H62.8265V122.976H59.8789V107.625H67.1995C70.8317 107.625 72.7484 110.03 72.7484 112.707C72.8274 113.85 72.4697 114.981 71.7469 115.873C71.0242 116.765 69.9897 117.352 68.8505 117.517L73.5215 122.743L73.5698 122.976ZM62.8265 110.342V115.248H67.2478C67.5882 115.276 67.9306 115.233 68.2534 115.122C68.5763 115.011 68.8725 114.835 69.1235 114.604C69.3746 114.374 69.5749 114.094 69.7119 113.783C69.8489 113.472 69.9197 113.135 69.9197 112.795C69.9197 112.456 69.8489 112.119 69.7119 111.808C69.5749 111.497 69.3746 111.217 69.1235 110.986C68.8725 110.756 68.5763 110.58 68.2534 110.469C67.9306 110.358 67.5882 110.315 67.2478 110.342H62.8265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4125 122.976H76.8799V107.649H88.4125V110.495H79.763V114.014H88.0662V116.707H79.763V120.114H88.4125V122.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.432 107.625H106.332V122.976H104.528L96.4339 112.619V122.952H93.5347V107.649H95.8863L103.432 117.148V107.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.124 120.114H114.071L112.75 123.008H109.601L116.511 107.681H119.676L126.586 123.008H123.421L122.124 120.114ZM118.098 110.896L115.239 117.429H120.957L118.098 110.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8583 37.8843C72.249 37.8843 69.6987 37.8122 67.2075 37.6679V45.5638C69.6934 45.6974 72.2436 45.7669 74.8583 45.7722C99.1477 45.7722 118.847 39.5757 118.847 31.9283V24.0645C118.847 31.6878 99.1477 37.8843 74.8583 37.8843Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.29 47.8085V55.6723C106.492 53.7885 118.846 48.6502 118.846 42.598V34.7341C118.846 40.7543 106.492 45.9247 89.29 47.8085Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8586 27.1909C65.529 27.2885 56.2224 26.2494 47.1465 24.0966V55.6723H51.3907L53.7101 33.3473C60.698 34.5137 67.7731 35.0849 74.8586 35.0547C99.1479 35.0547 118.847 28.8582 118.847 21.2188V13.355C118.847 20.9944 99.1479 27.1909 74.8586 27.1909Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8124 12.6977C93.9208 13.1706 106.098 16.2889 108.924 20.321C109.316 19.7995 109.533 19.1685 109.545 18.5174C109.545 13.7077 96.3449 9.69963 79.2795 9.12247L79.8191 5.04224C97.722 5.7156 112.13 9.9802 115.488 15.4633C115.963 14.7224 116.222 13.865 116.237 12.9863C116.237 5.77172 97.714 -0.0319824 74.8662 -0.0319824V24.0165H77.3306L78.8124 12.6977Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6885 42.4936C59.0254 42.6619 60.9099 42.8863 62.9877 43.0306V40.5376C61.2083 40.4034 59.4387 40.1624 57.6885 39.8162V42.4936Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2557 76.2578V89.0837C20.2557 95.713 16.1726 99.1119 10.5029 99.1119C5.09904 99.1119 0.500488 95.8413 0.500488 89.0837V76.2578H4.71247V89.0837C4.71247 93.0918 7.03189 95.2722 10.5352 95.2722C14.0384 95.2722 16.0357 92.9314 16.0357 89.0837V76.2578H20.2557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4192 76.1937H46.6633V98.6389H44.0299L32.1912 83.4884V98.6069H27.939V76.1616H31.3859L42.4192 90.0616V76.1937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8066 98.6469V76.2017H58.0186V98.6469H53.8066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2266 98.647V76.2578H81.406V80.33H69.4707V86.4464H80.7456V90.3502H69.4707V98.647H65.2266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.358 87.5686C110.294 93.3643 106.726 99.16 98.8095 99.16C90.8929 99.16 87.2607 93.4926 87.2607 87.6007C87.2607 81.7088 91.0539 75.7769 98.8417 75.7769C106.629 75.7769 110.423 81.7088 110.358 87.5686ZM91.4083 87.6648C91.5049 91.3442 93.5022 95.2882 98.8095 95.2882C104.117 95.2882 106.114 91.2801 106.178 87.6328C106.243 83.9854 104.117 79.6166 98.8095 79.6166C93.5022 79.6166 91.2875 83.8812 91.4083 87.6648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.677 98.6469H131.627L125.064 91.1518H120.973V98.6469H116.729V76.2017C120.296 76.2017 123.872 76.2017 127.44 76.2017C132.747 76.2017 135.55 79.7608 135.55 83.6326C135.55 86.7109 134.132 89.8131 129.856 90.6788L136.677 98.3343V98.6469ZM120.973 80.1697V87.3842H127.415C130.121 87.3842 131.281 85.5886 131.281 83.793C131.281 81.9973 130.089 80.2097 127.415 80.2097L120.973 80.1697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.256 82.4383L153.92 92.1779H153.114L145.939 82.4063V98.7111H141.694V76.2659H146.583L153.63 85.8853L160.676 76.2659H165.509V98.7111H161.264L161.256 82.4383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9219 120.114H43.8684L42.5476 123.008H39.4067L46.3086 107.681H49.4736L56.3835 123.008H53.2185L51.9219 120.114ZM47.8951 110.896L45.0361 117.429H50.7541L47.8951 110.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5698 122.976H70.1149L65.6211 117.854H62.8265V122.976H59.8789V107.625H67.1995C70.8317 107.625 72.7484 110.03 72.7484 112.707C72.8274 113.85 72.4697 114.981 71.7469 115.873C71.0242 116.765 69.9897 117.352 68.8505 117.517L73.5215 122.743L73.5698 122.976ZM62.8265 110.342V115.248H67.2478C67.5882 115.276 67.9306 115.233 68.2534 115.122C68.5763 115.011 68.8725 114.835 69.1235 114.604C69.3746 114.374 69.5749 114.094 69.7119 113.783C69.8489 113.472 69.9197 113.135 69.9197 112.795C69.9197 112.456 69.8489 112.119 69.7119 111.808C69.5749 111.497 69.3746 111.217 69.1235 110.986C68.8725 110.756 68.5763 110.58 68.2534 110.469C67.9306 110.358 67.5882 110.315 67.2478 110.342H62.8265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4125 122.976H76.8799V107.649H88.4125V110.495H79.763V114.014H88.0662V116.707H79.763V120.114H88.4125V122.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.432 107.625H106.332V122.976H104.528L96.4339 112.619V122.952H93.5347V107.649H95.8863L103.432 117.148V107.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.124 120.114H114.071L112.75 123.008H109.601L116.511 107.681H119.676L126.586 123.008H123.421L122.124 120.114ZM118.098 110.896L115.239 117.429H120.957L118.098 110.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8583 37.8843C72.249 37.8843 69.6987 37.8122 67.2075 37.6679V45.5638C69.6934 45.6974 72.2436 45.7669 74.8583 45.7722C99.1477 45.7722 118.847 39.5757 118.847 31.9283V24.0645C118.847 31.6878 99.1477 37.8843 74.8583 37.8843Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.29 47.8085V55.6723C106.492 53.7885 118.846 48.6502 118.846 42.598V34.7341C118.846 40.7543 106.492 45.9247 89.29 47.8085Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8586 27.1909C65.529 27.2885 56.2224 26.2494 47.1465 24.0966V55.6723H51.3907L53.7101 33.3473C60.698 34.5137 67.7731 35.0849 74.8586 35.0547C99.1479 35.0547 118.847 28.8582 118.847 21.2188V13.355C118.847 20.9944 99.1479 27.1909 74.8586 27.1909Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8124 12.6977C93.9208 13.1706 106.098 16.2889 108.924 20.321C109.316 19.7995 109.533 19.1685 109.545 18.5174C109.545 13.7077 96.3449 9.69963 79.2795 9.12247L79.8191 5.04224C97.722 5.7156 112.13 9.9802 115.488 15.4633C115.963 14.7224 116.222 13.865 116.237 12.9863C116.237 5.77172 97.714 -0.0319824 74.8662 -0.0319824V24.0165H77.3306L78.8124 12.6977Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6885 42.4936C59.0254 42.6619 60.9099 42.8863 62.9877 43.0306V40.5376C61.2083 40.4034 59.4387 40.1624 57.6885 39.8162V42.4936Z",
    fill: "#B84031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 123,
    fill: "white",
    transform: "translate(0.500488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/FooterLogo.ab7cfa1f2c911aede1d87d3618e08dea.svg";
export { ForwardRef as ReactComponent };